module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG2208d344c7584e28d53d9a2b6eab485f.2208d344.png";